<template>
<div class="sections-container">
  <div class="header-sections">
    <span class="title-section">Actividad</span>
  </div>
</div>
</template>
<script>
export default {
  name: 'CommerciaVueActivity',

  data () {
    return {}
  },
  mounted () { },
  methods: { }
}
</script>

<style scoped>
 @import '@/assets/styles/sections.css';
 @import '@/assets/styles/inputs.css';
</style>
